  import React from 'react';
import Navigation from './Navigation';
import Footer from './Footer';

const FAQ = () => {
  return (
    <div className="min-h-screen bg-[#050505] font-inter">
      <Navigation />
      
      {/* FAQ Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20">
        {/* Header */}
        <header className="mb-8 sm:mb-12">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
            Frequently Asked Questions about Solo Gigs
          </h1>
          <p className="text-lg sm:text-xl text-gray-300">
            Everything you need to know about going to concerts alone in London and how CrowdOne makes it safer and easier.
          </p>
        </header>

        {/* FAQ Items */}
        <div className="space-y-6">
          <div className="bg-gray-900 rounded-lg p-6 sm:p-8 border border-gray-800">
            <h2 className="text-xl sm:text-2xl font-bold text-white mb-4">
              Is it safe to go to a concert alone in London?
            </h2>
            <p className="text-lg text-gray-200 leading-relaxed">
              Generally, yes. London venues like the O2 Academy Brixton, The Roundhouse, and Eventim Apollo have strong security and crowd management. However, travelling to and from the venue late at night can feel vulnerable. This is why many solo fans prefer to meet a "Squad" beforehand—it ensures you have people to walk to the tube station with after the encore.
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-6 sm:p-8 border border-gray-800">
            <h2 className="text-xl sm:text-2xl font-bold text-white mb-4">
              How does CrowdOne verify that users are real?
            </h2>
            <p className="text-lg text-gray-200 leading-relaxed">
              We take safety seriously. Unlike Facebook groups or Reddit threads, CrowdOne requires Government ID Verification (processed securely via Stripe Identity) or a verifiable payment method before a user can enter a Squad Chat. This ensures that the person you are chatting with is who they say they are.
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-6 sm:p-8 border border-gray-800">
            <h2 className="text-xl sm:text-2xl font-bold text-white mb-4">
              Will it be awkward meeting strangers?
            </h2>
            <p className="text-lg text-gray-200 leading-relaxed">
              We designed the app to kill the awkwardness. You aren't meeting for a "date" or a long dinner; you are meeting for the music. We match you into small groups (4-6 people) based on the specific gig you are attending. Because you already have a shared obsession (the band), the conversation flows naturally.
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-6 sm:p-8 border border-gray-800">
            <h2 className="text-xl sm:text-2xl font-bold text-white mb-4">
              What happens if I don't click with my squad?
            </h2>
            <p className="text-lg text-gray-200 leading-relaxed">
              There is zero obligation. CrowdOne is a tool to facilitate the introduction, not a marriage contract. If you meet up for a pre-drink and want to head into the crowd on your own later, that is totally fine. You use the squad as much or as little as you need.
            </p>
          </div>

          <div className="bg-gray-900 rounded-lg p-6 sm:p-8 border border-gray-800">
            <h2 className="text-xl sm:text-2xl font-bold text-white mb-4">
              How do I find my squad at the venue?
            </h2>
            <p className="text-lg text-gray-200 leading-relaxed">
              "Meet by the bar" is a nightmare at sold-out shows. We use a feature called the Digital Totem—a specific, pinned location on the venue's floorplan (e.g., "Front Left, by the Sound Desk"). You can see exactly where your group is on the in-app map.
            </p>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-12 pt-8 border-t border-gray-800 text-center">
          <p className="text-lg sm:text-xl text-gray-200 mb-6">
            Ready to find your people?
          </p>
          <a
            href="/"
            className="inline-block bg-[#4ADE80] hover:bg-[#3bc96a] text-[#050505] font-bold py-3 px-8 rounded-lg transition-colors duration-200 text-lg"
          >
            Join the CrowdOne Pilot List here
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FAQ;
